module.exports = __webpack_public_path__ + "static/media/buffet.2f6b72df.jpg";